export default "__VITE_ASSET__b196d2fe__"